// extracted by mini-css-extract-plugin
export default {"popper_display":"styles-module_popper_display_kmHQzD","popperDisplay":"styles-module_popper_display_kmHQzD"};